import { createContext } from 'react';

const ProductListingPageContext = createContext(null);

export default ProductListingPageContext;
